import {Fragment, useState} from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useSWR from 'swr';
import HorizontalCardsList from '../HorizontalCardsList';
import Search from '../shared/Search';
import { Box, Typography } from '@mui/material';
import { getTranslation } from '../../utils/translate';

const RelationshipDialog = (props) => {
    const {
        title = '',
        helperText = 'Select a product to proceed',
        headCells = [],
        onSelect,
        url,
        payload = {},
        responseHandler = () => [],
        searchOnly,
        buttonText
    } = props;

    const [open, setOpen] = useState(false);
    const [searchResults, setSearchResults] = useState(null);
    const [fullWidth, setFullWidth] = useState(true);
    const [maxWidth, setMaxWidth] = useState('xs');
    const [selected, setSelected] = useState([]);

    const { data, isLoading } = useSWR({
        url,
        ...payload,
    });

    let processedData = [];

    if (data) {
        processedData = responseHandler(data);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleSelect = (selected) => {
        setSelected(selected);
    };

    const handleClose = () => {
        onSelect(selected);
        setOpen(false);
    };

    const handleSearchTriggered = () => {
        console.log('handleSearchTriggered');
    }

    const handleSearchCleared = () => {
        setSearchResults(null);
    }

    const handleSearchComplete = (results) => {
        setSearchResults(results?.beefCuts?.data
            ?.map(beefCut => {
                const translatedBeefCut = getTranslation(beefCut, { key: 'languages_id', code: 'en-US' });
                const imageUrl = `${process.env.REACT_APP_API_URL}/assets/${beefCut?.image}`;

                return {
                    id: beefCut?.id,
                    title: translatedBeefCut?.name || '',
                    description: translatedBeefCut?.description || '',
                    imageUrl: imageUrl || '',
                    data: beefCut,
                }
            }) || null);
    }

    return (
        <Fragment>
            <Button
                variant="contained"
                color="success"
                onClick={handleClickOpen}
            >
                {buttonText || `Link to ${title}`}
            </Button>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>
                    <Typography
                        className='form-title'
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '1rem',
                        }}
                    >
                        {helperText}
                    </Typography>

                    <Box
                        sx={{
                            mt: 1,
                        }}
                    >
                        <Search
                            handleSearchComplete={handleSearchComplete}
                            handleSearchTriggered={handleSearchTriggered}
                            handleSearchCleared={handleSearchCleared}
                            searchOnly={searchOnly}
                            compact
                        />
                    </Box>
                </DialogTitle>

                <DialogContent>
                    <HorizontalCardsList
                        headCells={headCells}
                        rows={
                            (searchResults || processedData)?.map(item => {
                                return {
                                    id: item?.id,
                                    title: item?.title || '',
                                    description: item?.description || '',
                                    imageUrl: item.imageUrl || '',
                                    url: item.url || '',
                                    data: item.data
                                }
                            })
                        }
                        onSelect={handleSelect}
                    />
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => {
                            setOpen(false);
                        }}
                        color="info"
                        variant='contained'
                    >
                        cancel
                    </Button>

                    <Button
                        onClick={handleClose}
                        color="success"
                        variant='contained'
                    >
                        Proceed
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default RelationshipDialog